// Mock data for The Grill Restaurant

export const restaurantInfo = {
  name: "The Grill",
  tagline: "Where Flavor Meets Tradition",
  description: "Jabalpur's Finest Dining Experience",
  rating: 4.2,
  reviewCount: 636,
  yearsEstablished: 15,
  menuItemCount: 200,
  address: "Jabalpur, Madhya Pradesh, India",
  phone: "+91 98765 43210",
  email: "info@thegrill.com",
  hours: {
    weekdays: "11:00 AM - 11:00 PM",
    weekends: "11:00 AM - 12:00 AM"
  },
  socialMedia: {
    facebook: "https://facebook.com/thegrill",
    instagram: "https://instagram.com/thegrilljabalpur",
    whatsapp: "https://wa.me/919876543210"
  }
};

export const signatureDishes = [
  {
    id: 1,
    name: "Chicken Tandoori Lahori",
    description: "Tender chicken marinated in authentic Lahori spices, grilled to perfection",
    price: "₹350-450",
    category: "Tandoori",
    image: "https://images.unsplash.com/photo-1610057099431-d73a1c9d2f2f?w=800",
    isSignature: true
  },
  {
    id: 2,
    name: "Chicken Rara Dhaba Style",
    description: "Rich, rustic dhaba-style curry with minced and chunky chicken",
    price: "₹320-400",
    category: "North Indian",
    image: "https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?w=800",
    isSignature: true
  },
  {
    id: 3,
    name: "Grilled Fish",
    description: "Fresh fish fillet marinated with herbs and grilled to smoky perfection",
    price: "₹400-500",
    category: "Continental",
    image: "https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?w=800",
    isSignature: true
  },
  {
    id: 4,
    name: "Butter Chicken",
    description: "Creamy tomato-based curry with tender chicken pieces",
    price: "₹300-380",
    category: "North Indian",
    image: "https://images.unsplash.com/photo-1603133872878-684f208fb84b?w=800",
    isSignature: true
  },
  {
    id: 5,
    name: "Korean Noodles",
    description: "Spicy stir-fried noodles with vegetables in Korean sauce",
    price: "₹250-320",
    category: "Chinese",
    image: "https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=800",
    isSignature: true
  },
  {
    id: 6,
    name: "Cheese Balls",
    description: "Crispy golden cheese balls with molten cheese center",
    price: "₹180-240",
    category: "Appetizer",
    image: "https://images.unsplash.com/photo-1541014741259-de529411b96a?w=800",
    isSignature: true
  },
  {
    id: 7,
    name: "Chicken Malai Tikka Roll",
    description: "Creamy malai tikka wrapped in soft paratha",
    price: "₹150-200",
    category: "Rolls",
    image: "https://images.unsplash.com/photo-1626645738196-c2a7c87a8f58?w=800",
    isSignature: false
  },
  {
    id: 8,
    name: "Non-Veg Platter",
    description: "Assorted grilled meats with accompaniments",
    price: "₹550-700",
    category: "Tandoori",
    image: "https://images.unsplash.com/photo-1544025162-d76694265947?w=800",
    isSignature: false
  }
];

export const menuCategories = [
  {
    id: "north-indian",
    name: "North Indian Specialties",
    items: [
      { name: "Butter Chicken", price: "₹350", description: "Creamy tomato curry with tender chicken" },
      { name: "Chicken Rara Dhaba Style", price: "₹380", description: "Rustic dhaba-style chicken curry" },
      { name: "Dal Makhani", price: "₹220", description: "Slow-cooked black lentils in butter" },
      { name: "Paneer Butter Masala", price: "₹280", description: "Cottage cheese in rich tomato gravy" },
      { name: "Kadai Chicken", price: "₹340", description: "Chicken cooked with bell peppers and spices" }
    ]
  },
  {
    id: "chinese",
    name: "Chinese Favorites",
    items: [
      { name: "Korean Noodles", price: "₹280", description: "Spicy Korean-style noodles" },
      { name: "Chicken Manchurian", price: "₹320", description: "Indo-Chinese chicken in tangy sauce" },
      { name: "Veg Hakka Noodles", price: "₹200", description: "Stir-fried noodles with vegetables" },
      { name: "Chicken Fried Rice", price: "₹240", description: "Classic fried rice with chicken" },
      { name: "Chilli Chicken", price: "₹340", description: "Spicy chicken with bell peppers" }
    ]
  },
  {
    id: "tandoori",
    name: "Tandoori Selection",
    items: [
      { name: "Chicken Tandoori Lahori", price: "₹400", description: "Authentic Lahori-style tandoori chicken" },
      { name: "Chicken Malai Tikka", price: "₹360", description: "Creamy marinated chicken tikka" },
      { name: "Fish Tikka", price: "₹420", description: "Marinated fish grilled in tandoor" },
      { name: "Paneer Tikka", price: "₹280", description: "Cottage cheese marinated and grilled" },
      { name: "Tandoori Platter", price: "₹650", description: "Assorted tandoori delights" }
    ]
  },
  {
    id: "continental",
    name: "Continental Delights",
    items: [
      { name: "Grilled Fish", price: "₹450", description: "Herb-marinated grilled fish fillet" },
      { name: "Chicken Steak", price: "₹420", description: "Juicy grilled chicken steak" },
      { name: "Pasta Alfredo", price: "₹320", description: "Creamy white sauce pasta" },
      { name: "Garlic Bread", price: "₹150", description: "Toasted bread with garlic butter" }
    ]
  },
  {
    id: "soya",
    name: "Soya Dishes",
    items: [
      { name: "Soya Chaap Masala", price: "₹260", description: "Soya chaap in rich masala gravy" },
      { name: "Tandoori Soya Chaap", price: "₹280", description: "Grilled soya chaap with tandoori spices" },
      { name: "Soya Keema", price: "₹240", description: "Minced soya in spicy gravy" },
      { name: "Malai Soya Chaap", price: "₹290", description: "Creamy soya chaap curry" }
    ]
  },
  {
    id: "vegetarian",
    name: "Vegetarian Options",
    items: [
      { name: "Paneer Butter Masala", price: "₹280", description: "Cottage cheese in butter gravy" },
      { name: "Veg Biryani", price: "₹220", description: "Aromatic rice with mixed vegetables" },
      { name: "Cheese Balls", price: "₹210", description: "Crispy cheese balls appetizer" },
      { name: "Veg Manchurian", price: "₹240", description: "Vegetable balls in Manchurian sauce" }
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Nisha",
    rating: 5,
    text: "The staff is incredibly humble and helpful. I was genuinely impressed by the ambience and service. The food quality is outstanding!",
    date: "2 months ago"
  },
  {
    id: 2,
    name: "Arpit Kumar",
    rating: 5,
    text: "Their chef is literally awesome! Tasty food every time. Must try foods - chicken tandoori lahori and chicken rara dhaba style. Simply amazing!",
    date: "1 month ago"
  },
  {
    id: 3,
    name: "Jasleen Hora",
    rating: 5,
    text: "My family members are crazy for this place. The taste is same since so many years. It's a foodie's paradise. Never disappoints!",
    date: "3 weeks ago"
  },
  {
    id: 4,
    name: "Prashant Pawar",
    rating: 5,
    text: "Never disappoints! Every dish tastes fresh, perfectly balanced in spices, salt, and oil. The consistency in quality is remarkable.",
    date: "2 weeks ago"
  },
  {
    id: 5,
    name: "Rohit Sharma",
    rating: 4,
    text: "Great place for family dinners. The party hall is perfect for celebrations. Staff is very accommodating and helpful.",
    date: "1 week ago"
  },
  {
    id: 6,
    name: "Meera Patel",
    rating: 5,
    text: "Best butter chicken in Jabalpur! The ambience is warm and welcoming. Highly recommend for anyone who loves good food.",
    date: "3 days ago"
  }
];

export const galleryImages = [
  { id: 1, url: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800", category: "ambience", caption: "Restaurant Interior" },
  { id: 2, url: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800", category: "ambience", caption: "Dining Area" },
  { id: 3, url: "https://images.unsplash.com/photo-1610057099431-d73a1c9d2f2f?w=800", category: "food", caption: "Tandoori Chicken" },
  { id: 4, url: "https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?w=800", category: "food", caption: "Chicken Curry" },
  { id: 5, url: "https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?w=800", category: "food", caption: "Grilled Fish" },
  { id: 6, url: "https://images.unsplash.com/photo-1603133872878-684f208fb84b?w=800", category: "food", caption: "Butter Chicken" },
  { id: 7, url: "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=800", category: "food", caption: "Food Platter" },
  { id: 8, url: "https://images.unsplash.com/photo-1551024601-bec78aea704b?w=800", category: "food", caption: "Desserts" },
  { id: 9, url: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=800", category: "ambience", caption: "Party Hall" },
  { id: 10, url: "https://images.unsplash.com/photo-1544025162-d76694265947?w=800", category: "food", caption: "Grilled Platter" },
  { id: 11, url: "https://images.unsplash.com/photo-1552566626-52f8b828add9?w=800", category: "ambience", caption: "Table Setting" },
  { id: 12, url: "https://images.unsplash.com/photo-1514933651103-005eec06c04b?w=800", category: "ambience", caption: "Restaurant Exterior" }
];

export const eventFeatures = [
  {
    icon: "Users",
    title: "40-50 Guest Capacity",
    description: "Comfortable seating for intimate to medium-sized celebrations"
  },
  {
    icon: "UtensilsCrossed",
    title: "Customized Menu",
    description: "Fresh, customizable menu options for your special event"
  },
  {
    icon: "Sparkles",
    title: "Professional Service",
    description: "Dedicated staff to ensure your event runs smoothly"
  },
  {
    icon: "CalendarCheck",
    title: "Easy Booking",
    description: "Simple booking process with guidance and support"
  }
];

export const whyChooseUs = [
  {
    icon: "ChefHat",
    title: "Expert Chefs",
    description: "Experienced chefs crafting authentic flavors with passion"
  },
  {
    icon: "Leaf",
    title: "Fresh Ingredients",
    description: "Daily-sourced fresh ingredients for every dish"
  },
  {
    icon: "BookOpen",
    title: "Extensive Menu",
    description: "200+ dishes across North Indian, Chinese, and Continental"
  },
  {
    icon: "Heart",
    title: "Consistent Quality",
    description: "Same great taste maintained for over 15 years"
  }
];
